<template>
    <nav class="w-full fixed left-0 top-0 h-14 md:h-28 shadow-md px-4 bg-white z-10 lg:px-6">
        <div class="lg:container h-full mx-auto flex items-center">
            <static-search-link to="/">
                <div class="hidden md:flex flex-col justify-between">
                    <icon-logo-graphic-text/>
                    <span
                        v-if="showLogoText"
                        class="hidden md:inline-block text-blue text-sm pt-2"
                    >The Fast and Easy way to find a recruitment agency.</span>
                </div>
                <icon-logo-graphic class="inline-block h-8 md:hidden"/>
            </static-search-link>

            <static-search-link class="ml-auto" to="/search-for-agencies">
                <input-button
                    class="rounded"
                    style-type="primary"
                >
                    <icon-search class="h-5 w-5 md:h-6 md:w-6"/>
                </input-button>
            </static-search-link>

            <input-button
                class="text-blue-40 text-2xl group flex-row"
                style-type="none"
                @onClick="onMenuClicked"
            >
                <span class="hidden md:inline">Menu</span>
                <icon-menu class="inline-block h-8 w-8 text-orange group-hover:text-blue-40 transition-all ease-in-out"/>
            </input-button>
        </div>
    </nav>
</template>

<script>
import InputButton from "Components/InputButton.vue";
import IconLogoGraphicText from "Components/Icons/IconLogoGraphicText.vue";
import IconSearch from "Components/Icons/IconSearch.vue";
import IconMenu from "Components/Icons/IconMenu.vue";
import IconLogoGraphic from "Components/Icons/IconLogoGraphic";
import StaticSearchLink from "../StaticSearchLink.vue";

export default {
    name: "NavBar",
    components: {
        IconLogoGraphic,
        IconMenu,
        IconSearch,
        IconLogoGraphicText,
        InputButton,
        StaticSearchLink,
    },
    props: {
        showLogoText: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        onMenuClicked() {
            this.$emit('onMenuClick');
        }
    }
}
</script>
